import { caseSourcesOptions } from "../../../lib/systemData"

import classesCell from './BodyCell.module.css'

const SourceBox = (data) => {
    const options = caseSourcesOptions();
    const label = options
        ? options.find(item => item.value == data?.data)?.label
        : null;

    // old code
    // const [label, setLabel] = useState(null)
    // useEffect(() => {
    //     let options = caseSourcesOptions()

    //     if (options) {
    //         let item = options.find(item => item.value == data?.data)
    //         if (item) {
    //             setLabel(item.label)
    //         }

    //     }
    // }, [data])
    
    return <div className={`${classesCell.body_cell}`}>{label && label}</div>
}

export default SourceBox